import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { LoadingOverlay } from "@/components/Loading/LoadingOverlay";

/** ローディング・エラー・一覧の3状態で共通の外枠と見出し */
export const BulkPageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
      不動産登記簿の一括取得
    </Typography>
    {children}
  </Box>
);

// 桁ごとの字幅をそろえ、カウント更新のたびに文字列がガタつかないようにする
const countTextSx = { fontVariantNumeric: "tabular-nums" } as const;

const ResolveCountText: React.FC<{ processed: number; total: number }> = ({
  processed,
  total,
}) =>
  total > 0 ? (
    // 左右を均等な列にして「/」を中央列に固定する。
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ ...countTextSx, textAlign: "right" }}
      >
        {processed.toLocaleString()}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ px: 0.5 }}>
        /
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ ...countTextSx, textAlign: "left" }}
      >
        {total.toLocaleString()}件
      </Typography>
    </Box>
  ) : null;

/**
 * 読み出し・照合の進行/完了表示。完了はチェックマークで伝わるため、
 * finished 時も文言は進行表示の件数（totalCodes/totalCodes）のまま据え置く
 */
export const BulkResolveOverlay: React.FC<{
  processedCodes: number;
  totalCodes: number;
  finished?: boolean;
}> = ({ processedCodes, totalCodes, finished }) => (
  <LoadingOverlay finished={finished}>
    <ResolveCountText
      processed={finished ? totalCodes : processedCodes}
      total={totalCodes}
    />
  </LoadingOverlay>
);

/** 受け渡しデータなし、照合エラー、全件不在の案内 */
export const BulkNoDataError: React.FC = () => (
  <BulkPageLayout>
    <Alert severity="error">
      表示できるデータがありません。この画面はリロードや再表示では復元されないため、DataLensの画面からもう一度実行してください。
    </Alert>
  </BulkPageLayout>
);
